export default "__VITE_ASSET__BuAVTyBY__"